import React, { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const SkltnLicence = () => {

    const [arry, setArry] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9])

    return (
        <div className="skltn-roweducation">
            {arry.map(info =>
                <div className="licenceItem" key={info}>
                    <Skeleton animation="wave" variant="rect" width={32 + '%'} height={25} />
                    <span className="time">
                        <Skeleton animation="wave" variant="rect" width={70 + '%'} height={25} />
                    </span>
                    <span className="score">
                        <Skeleton animation="wave" variant="rect" width={70 + '%'} height={25} />
                    </span>
                    <span className="grade">
                        <Skeleton animation="wave" variant="rect" width={70 + '%'} height={25} />
                    </span>
                    <Skeleton animation="wave" variant="rect" width={12 + '%'} height={25} />
                    <img src="/svg/licenceSVG.svg" />
                </div>
            )}
        </div>
    );
}

export default SkltnLicence;